import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';
import formatExternalMatches from './list/formatExternalMatches';

class AddSerializer extends BaseSerializer {
  deserialize(raw, dayInFuture) {
    const serverRes = raw.data || raw.error;
    const success = serverRes.statusCode == 200 || serverRes.statusCode == 404;
    if (!success) {
      return {
        statusCode: serverRes.statusCode || raw.status || 500,
        success: false,
        message: serverRes.message || 'Impossible de charger les matchs. Veuillez réessayer.',
        // ancien message: (serverRes.message || 'Erreur lors de la récupération') + ` Code d'erreur: ADS_ERR_${serverRes.statusCode || raw.status || '1000'}`
        data: null
      };
    }
    return {
      statuCode: 200,
      success: true,
      message: 'Ads got',
      data: formatExternalMatches(serverRes.data.matches, dayInFuture)
    };
  }

  serialize() {}
}

export const serializer = new AddSerializer();
